import { forwardRef, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './sidebar/sidebar.component';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthGuard } from '../common-service/auth-gurd.guard';
import { BreadcrumbModule } from './breadcrumb/';
import { InternalDashComponent } from './internal-dash/internal-dash.component';
import { NgxTinymceModule } from 'ngx-tinymce';
import { TinyeditorComponent } from './tinyeditor/tinyeditor.component';
import { MultiselectComponent } from './multiselect/multiselect.component';
import { ReactiveFormsModule, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CKEditorModule } from 'ckeditor4-angular';
import { CreateAgendaComponent } from './create-agenda/create-agenda.component';
import { AgendaViewComponent } from './agenda-view/agenda-view.component';
import { ModalComponent } from './modal/modal.component';

const commonRoutes: Routes = [
  { path: '', component: DashboardComponent, canActivate: [AuthGuard] },
  {
    path: 'internal', component: SidebarComponent,
    children: [
      { path: 'dashboard', component: InternalDashComponent, canActivate: [AuthGuard] },
      {
        path: 'grievance',
        loadChildren: () => import('./../griviance/griviance.module').then(c => c.GrivianceModule),
        canLoad: [AuthGuard]
      },
      {
        path: 'usrmgt',
        loadChildren: () => import('./../usermgt/usermgt.module').then(u => u.UsermgtModule),
        canLoad: [AuthGuard]
      },
      {
        path: 'inspection',
        loadChildren: () => import('./../inspection/inspection.module').then(ins => ins.InspectionModule),
        canLoad: [AuthGuard]
      },
      {
        path: 'travelagent',
        loadChildren: () => import('./../inspection/travelagent/travelagent.module').then(ta => ta.TravelAgentModule),
        canLoad: [AuthGuard]
      },
      {
        path: 'inspectionproforma',
        loadChildren: () => import('./../inspection/inspectionproforma/inspectionproforma.module').then(ip => ip.InspectionproformaModule),
        canLoad: [AuthGuard]
      },
      {
        path: 'inbound',
        loadChildren: () => import('../diarydak/inbound/inbound.module').then(inbound => inbound.InboundModule),
        canLoad: [AuthGuard]
      },
      {
        path: 'outbound',
        loadChildren: () => import('../diarydak/outbound/outbound.module').then(inbound => inbound.OutboundModule),
        canLoad: [AuthGuard]
      },
      {
        path: 'excu',
        loadChildren: () => import('../excucomm/excucomm.module').then(exc => exc.ExcucommModule),
      },
      {
        path: 'college',
        loadChildren: () => import('../college/college.module').then(college => college.CollegeModule),
      },
      {
        path: 'auditLog',
        loadChildren: () => import('../audit-log/audit-log.module').then(al => al.AuditLogModule),
      },
      {
        path: 'antiRagging',
        loadChildren: () => import('../anti-ragging/anti-ragging.module').then(ar => ar.AntiRaggingModule),
      },
      {
        path: 'orientationProgram',
        loadChildren: () => import('../anti-ragging-orientation-program/anti-ragging-orientation-program.module').then(ar => ar.AntiRaggingOrientationProgramModule),
      },
      {
        path: 'legal',
        loadChildren: () => import('../legal/legal.module').then(lm => lm.LegalModule),
      },
      {
        path: 'mdm',
        loadChildren: () => import('../mdm/mdm.module').then(mdm => mdm.MdmModule),
      },
      {
        path: 'fqsr',
        loadChildren: () => import('../fqsr-certificate/fqsr-certificate.module').then(fqsr => fqsr.FqsrCertificateModule),
      },
      {
        path: 'sla',
        loadChildren: () => import('../sla/sla.module').then(sla => sla.SlaModule),
      }, 
      {
        path: 'eligibility',
        loadChildren: () => import('../eligibility-certificate/eligibility-certificate.module').then(ec => ec.EligibilityCertificateModule),
      },
      {
        path: 'ptr',
        loadChildren: () => import('../ptr/ptr.module').then(p => p.PtrModule),
      },
      {
        path: 'ug',
        loadChildren: () => import('../ug/ug.module').then(ug => ug.UgModule),
      },
      {
        path: 'uidr',
        loadChildren: () => import('../uidr/uidr.module').then(uidr => uidr.UidrModule),
      },
    ]
  }
];

@NgModule({
    declarations: [SidebarComponent, DashboardComponent,
    MultiselectComponent,
    TinyeditorComponent, InternalDashComponent, CreateAgendaComponent, AgendaViewComponent, ModalComponent],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    CKEditorModule,
    RouterModule.forChild(commonRoutes),
    NgxTinymceModule.forRoot({
      baseURL: '//cdnjs.cloudflare.com/ajax/libs/tinymce/4.9.0/',
    })
    ,BreadcrumbModule
  ],
  
  exports: [
    SidebarComponent,
    DashboardComponent,
    MultiselectComponent,
    ModalComponent
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TinyeditorComponent),
      multi: true
    }
  ]
})
export class CommonModuleModule { }
